export default "__VITE_ASSET__2609bfc6__"